// extracted by css-extract-rspack-plugin
export default {"cls1":"Carousel-cls1_f6K","cls2":"Carousel-cls2_mpe Carousel-cls1_f6K"};